import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import { fetchCustomers, getError, getIsDataLoaded, getIsPending } from '@/ducks/customersReducer'

const withCustomersLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = false) =>
    // @ts-ignore
    props => (
      <InitialLoadWrapper
        loadAction={fetchCustomers}
        loadingSelector={getIsPending}
        loadedSelector={getIsDataLoaded}
        errorSelector={getError}
        forceLoadOnMount={forceLoadOnMount}
      >
        <Component {...props} />
      </InitialLoadWrapper>
    )

export default withCustomersLoaded
